import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "product_settings"
};
const _hoisted_2 = {
  class: "product_pool"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("b", null, "产品池列表")], -1);

const _hoisted_4 = {
  id: "pool_type",
  class: "pool_type"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "pool_li"
};
const _hoisted_7 = ["onClick"];

const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "添加产品池", -1);

const _hoisted_9 = {
  key: 0,
  class: "pool_details_layout"
};
const _hoisted_10 = {
  class: "pool_details_title"
};

const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "details_title_span"
}, "产品池名称：", -1);

const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "details_title_span"
}, "可兑换产品数量：", -1);

const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "dialog-footer"
};
import DynamicParams from "@com/DynamicParams.vue";
import ProductTable from "@com/marketing/ProductTable.vue";
import { reactive, ref, onMounted, watch } from "vue";
import Sortable from 'sortablejs';
import $ from "@util/base";
import { $msg } from "@/common/ui/msg";
import api from "@api/productChoose";
import { CopyDocument, Delete, Edit, Rank } from "@element-plus/icons-vue";
export default {
  __name: 'GiftProductSettings',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    travelProgramme: {
      type: Array
    },
    modify: {
      type: Boolean,
      default: false
    }
  },

  setup(__props, {
    expose: __expose
  }) {
    const props = __props;

    function aaaa() {
      console.log(getValue());
    }

    const operation = ref(poolOperation());

    function poolOperation() {
      if (props.readOnly) {
        return {
          move: false,
          modify: false,
          del: false,
          add: false,
          check: false
        };
      } else {
        return {
          move: !props.modify,
          modify: false,
          del: !props.modify,
          add: !props.modify,
          check: false
        };
      }
    }

    const template = {
      detailType: null,
      detailTitle: null,
      startTime: null,
      hotelItems: props.travelProgramme
    };
    watch(() => props.data, val => {
      poolData.value = initData();
      sortData.value = poolData.value;

      if ($.isNotEmpty(poolData.value)) {
        curPool.value = val[0];
        lastPool = val[0];
      }
    });
    watch(() => props.travelProgramme, val => {
      template.hotelItems = $.deepCopy(val);
    });
    const poolData = reactive({
      value: initData()
    });

    function initData() {
      if ($.isNotEmpty(props.data)) {
        return props.data.map(e => {
          e.tempId = $.uuid8();
          e.poolTitle = TYPE[e.busiType].title;
          e.poolValue = TYPE[e.busiType].val;

          if (e.itemList && e.itemList.length > 0) {
            e.itemList.map(m => {
              if (m.startDate && m.endDate) {
                m.useTime = [m.startDate, m.endDate];
              }

              return m;
            });
          }

          e.detailItems = e.itemList; // api.chooseList(TYPE[e.busiType].val, {
          //   codeList: e.itemList.map(item => item.code),
          // },
          //   (val) => {
          //     e.detailItems = val.itemList;
          //   }
          // );

          return e;
        });
      } else {
        return [];
      }
    }

    const TYPE = {
      1063001: {
        title: '商品',
        val: 'productSku'
      },
      1063002: {
        title: '旅行',
        val: 'travelPackage'
      },
      1063003: {
        title: '酒店',
        val: 'hotelRoom'
      },
      1063004: {
        title: '优惠券',
        val: 'coupon'
      }
    }; // if ($.isEmpty(props.data)) {
    //   for (let i in TYPE) {
    //     let template = {
    //       giftPoolName: null,
    //       maxExchangeNum: null,
    //       busiType: i,
    //       poolTitle: TYPE[i].title,
    //       poolValue: TYPE[i].val,
    //       tempId: $.uuid8(),
    //       detailItems: []
    //     }
    //     poolData.value.push(template)
    //   }
    // }

    function delPool(id) {
      poolData.value.remove(e => {
        return e.tempId === id;
      });

      if (id == curPool.value.tempId) {
        if (poolData.value.length > 0) {
          curPool.value = poolData.value[0];
        } else {
          curPool.value = [];
        }
      }
    }

    function openBusiType() {
      dialogVisible.value = true;
      resetForm();
    }

    function addRouteDay(busiType) {
      let template = {
        giftPoolName: null,
        maxExchangeNum: 1,
        busiType: busiType,
        poolTitle: TYPE[busiType].title,
        poolValue: TYPE[busiType].val,
        tempId: $.uuid8(),
        detailItems: []
      };
      poolData.value.push(template);

      if (poolData.value.length == 1) {
        curPool.value = poolData.value[0];
        lastPool = poolData.value[0];
      }
    }

    const dialogVisible = ref(false);
    const busiTypeFormRef = ref('');
    const busiTypeForm = reactive({
      type: ''
    });
    const trafficRules = {
      type: [{
        required: true,
        message: '请选择池类型',
        trigger: 'change'
      }]
    };

    const submitForm = () => {
      busiTypeFormRef.value.validate(valid => {
        if (valid) {
          addRouteDay(busiTypeForm.type);
          dialogVisible.value = false; // let index = poolData.value.findIndex( e => e.busiType == busiTypeForm.type)
          // if (index < 0) {
          //   addRouteDay(busiTypeForm.type)
          //   dialogVisible.value = false
          // } else {
          //   $msg.error(`已存在${TYPE[busiTypeForm.type].title}池`)
          // }
        }
      });
    };

    const resetForm = () => {
      if (!busiTypeFormRef.value) return;
      busiTypeFormRef.value.resetFields();
    };

    const productPoolRef = ref(null);
    const curPool = reactive({
      value: null
    });
    var lastPool = null;

    function switchPool(data) {
      if (data.tempId != curPool.value.tempId) {
        // curPool.value.detailItems = productPoolRef.value.getValue()
        let routeDetails = curPool.value.detailItems; //routeDetails数据保存在池中

        lastPool.detailItems = routeDetails; //切换当前池

        curPool.value = data; //记录上次池

        lastPool = data;
      }
    }

    function checkData(list) {
      const promises = [];

      for (let i = 0; i < list.length; i++) {
        promises.push(check(list[i], list[i].detailItems));
      }

      return Promise.all(promises).then(res => {
        console.log('checkData:s->', res);
        return res.every(e => {
          return e;
        });
      });
    }

    function check(day, routeDetails) {
      return new Promise((resolve, reject) => {
        if ($.isEmpty(day.giftPoolName)) {
          $msg.error("请填写" + day.poolTitle + "池名称");
          resolve(false);
        }

        if ($.isEmpty(day.maxExchangeNum)) {
          $msg.error("请填写" + day.poolTitle + "池兑换产品数量");
          resolve(false);
        }

        if (day.maxExchangeNum > routeDetails.length) {
          $msg.error(day.poolTitle + "池兑换产品数量不能大于池内数量");
          resolve(false);
        }

        if ($.isEmpty(routeDetails)) {
          $msg.error("请设置" + day.poolTitle + "池产品详情");
          resolve(false);
        }

        day.detailItems.forEach(item => {
          if (day.busiType == '1063002' || day.busiType == '1063003') {
            if ($.isEmpty(item.useTime) || item.useTime.length < 2) {
              $msg.error("请设置" + item.name + "可用时间");
              resolve(false);
            }

            if ($.isEmpty(item.isFallPrice)) {
              $msg.error("请设置" + item.name + "是否补差价");
              resolve(false);
            }

            if (item.isFallPrice == '1') {
              if ($.isEmpty(item.specifyMoney)) {
                $msg.error("请设置" + item.name + "指定金额");
                resolve(false);
              }
            }
          }
        });
        resolve(true);
      });
    }

    const sortData = reactive({
      value: poolData.value
    });
    onMounted(() => {
      if (!props.readOnly) {
        const ul = document.querySelector('#pool_type');
        Sortable.create(ul, {
          handle: ".move",
          animation: 150,
          onEnd: function (evt) {
            const currRow = sortData.value.splice(evt.oldIndex, 1)[0];
            sortData.value.splice(evt.newIndex, 0, currRow);
          }
        });
      }
    });

    function handerData(poolData) {
      for (const day of poolData) {
        day.itemList = day.detailItems.map(item => {
          return {
            code: item.code,
            name: item.name,
            childrenCode: item.childrenCode,
            startDate: item.useTime && item.useTime.length > 0 ? item.useTime[0] : null,
            endDate: item.useTime && item.useTime.length > 0 ? item.useTime[1] : null,
            isFallPrice: item.isFallPrice,
            specifyType: item.specifyType,
            specifyMoney: item.specifyMoney
          };
        });
        delete day.tempId;
        delete day.poolTitle;
        delete day.poolValue;
        delete day.detailItems;
      }

      return poolData;
    }

    function getValue() {
      return new Promise((resolve, reject) => {
        checkData(poolData.value).then(res => {
          console.log(res);

          if (res) {
            resolve(handerData($.deepCopy(poolData.value)));
          } else {
            resolve(false);
          }
        });
      });
    }

    function add() {
      openDrawer();
      if (!addTableRef.value) return;
      addTableRef.value.clearSelection();
    }

    const drawer = ref(false);
    const typeKey = ref(null);
    const addTableRef = ref(null);

    function openDrawer() {
      typeKey.value = curPool.value.poolValue;
      drawer.value = true;
    }

    function closeDrawer() {
      drawer.value = false;
    }

    function saveProduct() {
      let data = addTableRef.value.getSelectData();

      if ($.isEmpty(data)) {
        $msg.error("请勾选需要添加的产品");
      } else {
        // curPool.value.detailItems = data
        let newData = [...curPool.value.detailItems, ...data];
        let map = new Map();

        for (let item of newData) {
          if (item.childrenCode) {
            if (!map.has(item.childrenCode)) {
              map.set(item.childrenCode, item);
            }
          } else {
            if (!map.has(item.code)) {
              map.set(item.code, item);
            }
          }
        }

        let newArr = [...map.values()];
        curPool.value.detailItems = newArr;
        productPoolRef.value.doLayout();
        closeDrawer();
      }
    }

    function deletePoolItem(index) {
      console.log(index);
      console.log(curPool.value.detailItems);
      curPool.value.detailItems.splice(index, 1);
    }

    function disabledDate(time, row) {
      if (!row.startTime || !row.endTime) return false;
      const startDate = new Date(row.startTime);
      const endDate = new Date(row.endTime);
      return time.getTime() < startDate.getTime() || time.getTime() > endDate.getTime();
    }

    const objectSpanMethod = ({
      row,
      column,
      rowIndex,
      columnIndex
    }) => {
      if (columnIndex === 6 || columnIndex === 7) {
        if (curPool.value && (curPool.value.busiType == '1063002' || curPool.value.busiType == '1063003')) {
          if (rowIndex === 0) {
            console.log(rowIndex);
            return {
              rowspan: curPool.value.detailItems.length,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      }
    };

    __expose({
      getValue
    });

    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      const _component_Close = _resolveComponent("Close");

      const _component_Plus = _resolveComponent("Plus");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_el_drawer = _resolveComponent("el-drawer");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(poolData.value, item => {
        return _openBlock(), _createElementBlock("li", {
          key: item.tempId,
          class: _normalizeClass({
            active: curPool.value ? item.tempId == curPool.value.tempId : true
          }),
          onClick: $event => switchPool(item)
        }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(item.poolTitle) + "池", 1), !__props.readOnly && !__props.modify ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          class: "move",
          size: 18
        }, {
          default: _withCtx(() => [_createVNode(_unref(Rank))]),
          _: 1
        })) : _createCommentVNode("", true)]), !__props.readOnly && !__props.modify ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "del",
          onClick: _withModifiers($event => delPool(item.tempId), ["stop"])
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Close)]),
          _: 1
        })], 8, _hoisted_7)) : _createCommentVNode("", true)], 10, _hoisted_5);
      }), 128))]), !__props.readOnly && !__props.modify ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "dashed_but",
        onClick: openBusiType
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Plus)]),
        _: 1
      }), _hoisted_8])) : _createCommentVNode("", true)]), curPool.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_el_input, {
        class: "details_title_input",
        modelValue: curPool.value.giftPoolName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => curPool.value.giftPoolName = $event),
        placeholder: "请输入",
        clearable: true,
        disabled: __props.readOnly || __props.modify
      }, null, 8, ["modelValue", "disabled"]), _hoisted_12, _createVNode(_component_el_input_number, {
        modelValue: curPool.value.maxExchangeNum,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => curPool.value.maxExchangeNum = $event),
        min: 1,
        disabled: __props.readOnly || __props.modify,
        class: "margin_left"
      }, null, 8, ["modelValue", "disabled"])]), _createVNode(_component_el_table, {
        ref_key: "productPoolRef",
        ref: productPoolRef,
        data: curPool.value.detailItems,
        "span-method": objectSpanMethod
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "产品图片",
          width: "105"
        }, {
          default: _withCtx(scope => [_createElementVNode("img", {
            src: scope.row.mainPic,
            style: {
              width: '75px',
              height: '75px'
            }
          }, null, 8, _hoisted_13)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "产品名称",
          prop: "name",
          width: "200"
        }), _createVNode(_component_el_table_column, {
          label: "产品编号",
          prop: "code",
          width: "100"
        }), _createVNode(_component_el_table_column, {
          label: "sku/套餐/房型",
          prop: "childName",
          width: "200"
        }), _createVNode(_component_el_table_column, {
          label: "产品类型",
          prop: "category",
          width: "100"
        }), curPool.value.busiType == '1063002' || curPool.value.busiType == '1063003' ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 0,
          label: "可用时间设置",
          prop: "useTime",
          width: "230"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_date_picker, {
            style: {
              "width": "200px"
            },
            modelValue: scope.row.useTime,
            "onUpdate:modelValue": $event => scope.row.useTime = $event,
            type: "daterange",
            "range-separator": "至",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            "disabled-date": time => disabledDate(time, scope.row),
            disabled: __props.readOnly || __props.modify
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled-date", "disabled"])]),
          _: 1
        })) : _createCommentVNode("", true), curPool.value.busiType == '1063002' || curPool.value.busiType == '1063003' ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 1,
          label: "是否补差价",
          prop: "isDifference",
          width: "200"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_radio_group, {
            modelValue: scope.row.isFallPrice,
            "onUpdate:modelValue": $event => scope.row.isFallPrice = $event,
            disabled: __props.readOnly || __props.modify
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_createTextVNode("是")]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 0
            }, {
              default: _withCtx(() => [_createTextVNode("否")]),
              _: 1
            })]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])]),
          _: 1
        })) : _createCommentVNode("", true), curPool.value.busiType == '1063002' || curPool.value.busiType == '1063003' ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 2,
          label: "指定金额",
          prop: "designatedAmount",
          width: "200"
        }, {
          default: _withCtx(scope => [scope.row.isFallPrice == '1' ? (_openBlock(), _createBlock(_component_el_input, {
            key: 0,
            style: {
              "width": "100px"
            },
            modelValue: scope.row.specifyMoney,
            "onUpdate:modelValue": $event => scope.row.specifyMoney = $event,
            disabled: __props.readOnly || __props.modify
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true)]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
          label: "操作",
          align: "center"
        }, {
          default: _withCtx(scope => [operation.value.del ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0,
            class: "pointer",
            onClick: $event => deletePoolItem(scope.$index),
            size: 18
          }, {
            default: _withCtx(() => [_createVNode(_unref(Delete))]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), operation.value.add ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "dashed_but",
        onClick: add
      }, " 添加选项 ")) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => dialogVisible.value = $event),
        title: "选择",
        width: "35%",
        top: "35vh",
        class: "base_dialog"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_14, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitForm
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "busiTypeFormRef",
          ref: busiTypeFormRef,
          model: busiTypeForm,
          rules: trafficRules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "池类型",
            prop: "type"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: busiTypeForm.type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => busiTypeForm.type = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: "1063001"
              }, {
                default: _withCtx(() => [_createTextVNode("商品")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: "1063002"
              }, {
                default: _withCtx(() => [_createTextVNode("旅行")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: "1063003"
              }, {
                default: _withCtx(() => [_createTextVNode("酒店")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: "1063004"
              }, {
                default: _withCtx(() => [_createTextVNode("优惠券")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_drawer, {
        modelValue: drawer.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => drawer.value = $event),
        title: "添加产品",
        direction: "rtl",
        "close-on-click-modal": false,
        size: "60%",
        "custom-class": "base_drawer"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_button, {
          onClick: closeDrawer
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: saveProduct,
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(ProductTable, {
          type: "add",
          ref_key: "addTableRef",
          ref: addTableRef,
          typeKey: typeKey.value
        }, null, 8, ["typeKey"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};